// extracted by mini-css-extract-plugin
export var standaloneTable = "_1e-0";
export var standaloneTableWithBodyFill = "_1e-1";
export var withExtraHeader = "_1e-2";